import React, { useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ConfigureAddressDrawer from "components/common/ConfigureAddressDrawer";
import { ConfigureAddressValidationType } from "utils/addressFormat";

interface LocationDetailsDrawerProps {
  open: boolean;
  selectedAddressId?: string;
  editMode?: boolean;
  handleSuccess: () => void;
  handleCloseDrawer: (isRefetchData?: boolean) => void;
}

const LocationDetailsDrawer: React.FC<LocationDetailsDrawerProps> = (props) => {
  const {
    open,
    selectedAddressId,
    editMode = false,
    handleSuccess,
    handleCloseDrawer,
  } = props;
  const { t } = useTranslation();

  const [isReadOnly, setReadOnly] = useState<boolean>(false);

  // Reset only while opening, and before paint: the drawer stays mounted as
  // it animates out, so a reset on close plays out in full view.
  useLayoutEffect(() => {
    if (!open) return;

    setReadOnly(Boolean(selectedAddressId) && !editMode);
  }, [open, editMode, selectedAddressId]);

  const drawerTitle = isReadOnly
    ? [t("View Location")]
    : selectedAddressId
      ? [t("Edit Location")]
      : [t("Add Location")];

  return (
    <ConfigureAddressDrawer
      open={open}
      drawerTitle={drawerTitle}
      onClose={handleCloseDrawer}
      onSuccess={() => {
        handleSuccess();
        handleCloseDrawer(true);
      }}
      selectedAddressId={selectedAddressId}
      readOnly={isReadOnly}
      setReadOnly={setReadOnly}
      customAddressName={true}
      validationType={ConfigureAddressValidationType.CREATE}
    />
  );
};

export default LocationDetailsDrawer;
